import React from "react";
import { Toaster } from "sonner";
import "../App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import DefaultScrollTop from "../components/Layout/ScrollToTop";
import ScrollButton from "../components/Layout/ScrollButton";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import HomePage from "./HomePage";
import ProductsPage from "./ProductsPage";
import SolutionsPage from "./SolutionsPage";
import IndustriesPage from "./IndustriesPage";
import PricingPage from "./PricingPage";
import ResourcesPage from "./ResourcesPage";
import PartnerPage from "./PartnerPage";
import BlogPage from "./BlogPage";
import DemoPage from "./DemoPage";
import ContactPage from "./ContactPage";
import CheckoutPage from "./CheckoutPage";
import ProductDetailPage from "./ProductDetailPage";
import IndustryDetailPage from "./IndustryDetailPage";
import SolutionsDetailPage from "./SolutionDetailPage";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsPage from "./TermsPage";
import AboutUs from './AboutUs'
import UnsubcribePage from './Unsubcribe'
import Payment from './Payment'
import PaymentStatus from './PaymentStatus'
import usePageTracking from "./usePageTracking"

function App() {
    usePageTracking();
    const location = useLocation();
    const hideLayout = location.pathname === "/unsubscribe";
    return (
        <>
            <DefaultScrollTop />
            {!hideLayout && <Header />}
            <main>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/products" element={<ProductsPage />} />
                    <Route path="/products/:featureId" element={<ProductDetailPage />} />
                    <Route path="/solutions" element={<SolutionsPage />} />
                    <Route path="/solutions/:featureId" element={<SolutionsDetailPage />} />
                    <Route path="/industries" element={<IndustriesPage />} />
                    <Route path="/industries/:industryId" element={<IndustryDetailPage />} />
                    <Route path="/plans" element={<PricingPage />} />
                    <Route path="/resources" element={<ResourcesPage />} />
                    <Route path="/partner" element={<PartnerPage />} />
                    <Route path="/blog" element={<BlogPage />} />
                    <Route path="/demo" element={<DemoPage />} />
                    <Route path="/checkout" element={<CheckoutPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
                    <Route path="/termsAndCondition" element={<TermsPage />} />
                    <Route path="/unsubscribe" element={<UnsubcribePage />} />
                    <Route path="/payment" element={<Payment />} />
                    <Route path="/paymentstatus" element={<PaymentStatus />} />
                </Routes>
            </main>
            {!hideLayout && <Footer />}
            <ScrollButton />
        </>
    );
}

export default App;